import clsx from 'clsx';
import React from 'react';

import { IMGIX_URL } from '@src/env';

import Section from './Section';

interface TheInformationDifferenceProps {
  headerClass?: string;
}

const TheInformationDifference = ({ headerClass }: TheInformationDifferenceProps) => {
  return (
    <div className="mx-auto mt-64 max-w-[1068px] sm:mt-96">
      <h1 className="m-0 text-center font-suisse-works text-headline-xs text-black sm:text-headline-lg lg:text-headline-xl">
        The Information{' '}
        <span className={clsx('font-bold italic text-primary-magenta', headerClass)}>
          Difference
        </span>
      </h1>
      <Section
        title="A Focus on Exclusive Reporting"
        text="The Information’s newsroom is focused on tech, finance and media, meaning you get specialized coverage of each industry by reporters who are experts in their respective topics. <span>Our editors have decades of experience at publications such as The New York Times, The Wall Street Journal, Forbes and Reuters. Their relationships and expertise mean we get scoops more quickly than some of the bigger players.</span>"
        imageSrc={`${IMGIX_URL}/global/subscribe/a_focus_on_exclusive_reporting.png`}
        className="mt-32 sm:mt-48 sm:flex-row"
      />
      <Section
        title="Insights Worth Your Time"
        text="Our subscribers are busy leaders, so we only publish reporting that’s different from anything you’ll read anywhere else, whether it’s details on venture capital strategy or a deep-dive investigation into fintech’s impact on the banking world. <span>Our daily newsletters bring you the highlights from our reporting and across the industry, making it easier than ever for you to make informed, strategic decisions.</span>"
        imageSrc={`${IMGIX_URL}/global/subscribe/insights_worth_your_time.png`}
        className="mt-48 sm:mt-64 sm:flex-row md:flex-row-reverse lg:mt-80"
      />
    </div>
  );
};

export default TheInformationDifference;
